/** Common Pages */
export const GET_FILE_PATH = "GET_FILE_PATH";
export const COMP_PERM = "COMP_PERM";
export const COMP_PERM_STRING = "COMP_PERM_STRING";
export const IS_SUCCESS       = "IS_SUCCESS";

/* Login Page */
export const USER_LOADED = "USER_LOADED";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const SAVE_TOKEN = "SAVE_TOKEN";
export const IS_VALID_KEY = "IS_VALID_KEY";
export const ROLES_DATA = "ROLES_DATA";
export const GET_ALL_ROLES_DATA_RECORD = "GET_ALL_ROLES_DATA_RECORD";
export const VALID_USER = "VALID_USER";

/** User Page */
export const API_KEY = "API_KEY";
export const USER_ROLES = "USER_ROLES";
export const RESOURCES_DATA = "RESOURCES_DATA";
export const IS_CONFIG_USER = "IS_CONFIG_USER";
export const USER_ROLE_LIST = "USER_ROLE_LIST";
export const VUSER_ROLE_LIST_TOTALRECORDS = "VUSER_ROLE_LIST_TOTALRECORDS";
export const GET_API_KEY = "GET_API_KEY";
export const GET_ALL_USER = "GET_ALL_USER";
export const GET_ALL_USER_TOTAL_RECORD = "GET_ALL_USER_TOTAL_RECORD";

/** License Page */
export const KEY_GENERATE = "KEY_GENERATE";
export const IS_USER_CREATE = "IS_USER_CREATE";
export const GET_ALL_LICENSE_DATA = "GET_ALL_LICENSE_DATA";
export const GET_ALL_LICENSE_DATA_RECORD = "GET_ALL_LICENSE_DATA_RECORD";

/* Job List */
export const JOB_LIST = "JOB_LIST";
export const BACKEND_JOBS = "BACKEND_JOBS";
export const DOWNLOAD_JOB = "DOWNLOAD_JOB";

/** ServerInfo Page */
export const SERVER_STATE = "SERVER_STATE";

/** Chart Display */
export const CLUSTER_DATA = "CLUSTER_DATA";

/** Dashboard Page */
export const LOG_SNIPPET = "LOG_SNIPPET";
export const GET_FINISH_JOB_LIST = "GET_FINISH_JOB_LIST";
export const GET_FINISH_JOB_TOTAL_RECORDS = "GET_FINISH_JOB_TOTAL_RECORDS";
export const GET_VERSION = "GET_VERSION";
export const REDIRECT = "REDIRECT";
export const SET_LOG_LEVEL = "SET_LOG_LEVEL";
export const CONNECTION_STATUS = "CONNECTION_STATUS";
export const GET_LIVE_JOB_LIST = "GET_LIVE_JOB_LIST";
export const GET_LIVE_JOB_TOTAL_RECORDS = "GET_LIVE_JOB_TOTAL_RECORDS";
export const GET_DATA_QUALITY_CHART_DATA = "GET_DATA_QUALITY_CHART_DATA";
export const GET_DATA_QUALITY_ASSET_ID = "GET_DATA_QUALITY_ASSET_ID";
export const GET_DATA_QUALITY_TIME = "GET_DATA_QUALITY_TIME";




/** Config Pages */
export const CONFIG_CONTENT = "CONFIG_CONTENT";
export const SELECT_SCHEMA = "SELECT_SCHEMA";
export const SELECT_UI_SCHEMA = "SELECT_UI_SCHEMA";
export const SET_OPERATOR = "SET_OPERATOR";
export const APP_CONFIG_DATA = "APP_CONFIG_DATA";
export const APP_CONFIG_DATA_TOTALRECORDS = "APP_CONFIG_DATA_TOTALRECORDS";
export const GET_ALL_SYS_CONFIG = "GET_ALL_SYS_CONFIG";
export const GET_ALL_DATA_PROVIDER_TOTAL_RECORD = "GET_ALL_DATA_PROVIDER_TOTAL_RECORD";

/** Log List */
export const LOG_FILES = "LOG_FILES";

/** BCSettings */
export const DATA_LOADING = "DATA_LOADING";
export const PROGRESS_LOADING = "PROGRESS_LOADING";


/**Manage User */
export const USER_DATA = "USER_DATA";

/**Node Info */
export const GET_NODE_INFO_DATA = "GET_NODE_INFO_DATA";
export const GET_TOTAL_RECORD_NODE_INFO = "GET_TOTAL_RECORD_NODE_INFO";

/** System Provider */
export const GET_DP_RIGS_LIST = 'GET_DP_RIGS_LIST';
export const GET_DP_DP_LIST = "GET_DP_DP_LIST";
export const GET_DP_BUNIT_LIST = "GET_DP_BUNIT_LIST";
export const GET_NODE_INFO_LIST = "GET_NODE_INFO_LIST";

/* Add user loder */
export const LOADING_ON = 'LOADING_ON';
export const LOADING_OFF = 'LOADING_OFF';

/* Change Password */
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";

/** */
export const GET_ACTIVE_DEVICES = "GET_ACTIVE_DEVICES";
export const GET_DEVICE_CHANNELS = "GET_DEVICE_CHANNELS";
export const SET_YH_ADDRESS = "SET_YH_ADDRESS";
export const SET_YH_PORT = "SET_YH_PORT";
export const SET_MONITOR_DEVICE = "SET_MONITOR_DEVICE";
export const SET_CHANNEL_LIST = "SET_CHANNEL_LIST";
export const SET_HISTORICAL_DEVICES = "SET_HISTORICAL_DEVICES";
export const HISTORICAL_DEVICES_LOADING = "HISTORICAL_DEVICES_LOADING";
export const DATA_QUALITY_LOADING = "DATA_QUALITY_LOADING";
export const ACTIVE_DEVICE_LOADING = "ACTIVE_DEVICE_LOADING";
export const SET_START_MONITORING = "SET_START_MONITORING";
export const SET_ACTIVE_WELLS = "SET_ACTIVE_WELLS";
export const SET_HISTORICAL_DATAVIEWER_TOTAL_ROWS = "SET_HISTORICAL_DATAVIEWER_TOTAL_ROWS";
export const SET_HISTORICAL_DATAVIEWER_TOTAL_PAGES = "SET_HISTORICAL_DATAVIEWER_TOTAL_PAGES";
export const RIG_WELL_DATA = "RIG_WELL_DATA";
export const HISTORICAL_DATAVIEWER_LOADING = "HISTORICAL_DATAVIEWER_LOADING";
export const SET_HISTORICAL_DATAVIEWER_HEADER = "SET_HISTORICAL_DATAVIEWER_HEADER";
export const SET_DATA_QUALITY_TOTAL_RECORD = "SET_DATA_QUALITY_TOTAL_RECORD";
export const SET_DATA_QUALITY_TIME = "SET_DATA_QUALITY_TIME";
export const SET_HISTORICAL_DATAVIEWER = "SET_HISTORICAL_DATAVIEWER";
export const SET_GET_LOG = "SET_GET_LOG";
export const SET_CONFIGURAION_DATA = "SET_CONFIGURAION_DATA";
export const SET_GET_CONFIGURAION_DATA = "SET_GET_CONFIGURAION_DATA";
export const GET_COLOR_DATA = "GET_COLOR_DATA";

/* DQ result card */
export const SET_CARD_FOR_CLICK = "SET_CARD_FOR_CLICK";
export const GET_ACTIVE_WELL_DEVICES_DATA = "GET_ACTIVE_WELL_DEVICES_DATA";
export const SET_DATA_LOG_MNEMONIC = "SET_DATA_LOG_MNEMONIC";
export const SET_DATA_CHANNEL_TEMPLATE = "SET_DATA_CHANNEL_TEMPLATE";

export const SET_DATA_ASPECT_TEMPLATE = "SET_DATA_ASPECT_TEMPLATE";
export const SET_DATA_ASPECT_DAY_TEMPLATE = "SET_DATA_ASPECT_DAY_TEMPLATE";
export const GET_CARD_DATA = "GET_CARD_DATA";
export const SET_RAW_DATA = "SET_RAW_DATA";
export const SET_RAW_TOTAL_RECORD = "SET_RAW_TOTAL_RECORD";
export const WELL_DATAPROVIDER_DATA = "WELL_DATAPROVIDER_DATA";
export const SET_DATE_DATAPROVIDER = "SET_DATE_DATAPROVIDER";
export const GET_REPORT_FILTER_DATA = "GET_REPORT_FILTER_DATA";
export const GET_REPORT_DATA = "GET_REPORT_DATA";
export const SET_AUDIT_LIST = "SET_AUDIT_LIST";
export const SET_DATA_ASPECT_DAY_TOTAL_RECORDS = "SET_DATA_ASPECT_DAY_TOTAL_RECORDS";
export const CLUSTER_DATA_TEMPLATE = "CLUSTER_DATA_TEMPLATE";
export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const GET_CARD_DATA_TOTALRECORD = "GET_CARD_DATA_TOTALRECORD";
export const GET_SYNC_LIST = "GET_SYNC_LIST";
export const GET_SYNC_ACTION = "GET_SYNC_ACTION";
export const GET_SYNC_DOWNLOAD = "GET_SYNC_DOWNLOAD";








